module.exports = __webpack_public_path__ + "media/assets/icons/sand-clock-a45fce60422bbac0302cc9649c76a884.svg";